import { OrderedList as OriginalOrderedList } from "@tiptap/extension-list";

export const OrderedList = OriginalOrderedList.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        class: "flex-1 pl-4 sm:pl-7 list-decimal [&>li>p]:my-0",
      },
    };
  },
});
